export default {
      id: "eye-off-usage",
      viewBox: "0 0 24 24",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#eye-off-usage",
      toString: function () {
        return this.url;
      }
    }